import React, { useRef, useState } from "react";
import { useEffect } from "react";
import Buttons from "../../components/ui/button/Buttons";
import FormCreator from "../../components/Forms/FormCreator";
import { useLazyGetAllDropDownsForMemberDirectoryQuery } from "../../app/services/common/commonApi";
import MolGrid from "../../components/Grid/MolGrid";
import { encryptAESID } from "../../utils/Encryption";
import { ViewGreenMarkProjectFormData } from "./data/ViewGreenMarkProjectForm.Data";
import { ViewGreenMarkProjectConfig } from "./data/ViewGreenMarkProjectTable.Data";
import {
  useDownloadSheetForGreenMarkProjectListMutation,
  useGetGreenMarkProjectListMutation,
} from "../../app/services/CPD/CPDApi";
import { setAllDropDownField } from "./utils/dropdownUtils";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import { APIUrl } from "../../utils/API/fetchBaseQuery";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";

const ViewGreenMarkProjectList = () => {
  const navigate = useNavigate();
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [formData, setFormData] = useState(ViewGreenMarkProjectFormData);
  const viewIndividualMembersRef = useRef();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    SearchText: null,
    Projects: null,
    AwardRating: null,
    GreenMarkProjectCatagory: null,
    ProjectNumber:null,
    ProjectName:null
  });
  const [
    getGreenMarkProjectList,
    {
      isSuccess: isSuccessList,
      isLoading: isFetchingList,
      data: getGreenMarkProjectListData,
    },
  ] = useGetGreenMarkProjectListMutation();
  const [
    getAllDropdownData,
    {
      isLoading: getDropdownDataIsLoading,
      data: allDropDownResponse,
      isSuccess: getAllDropdownDataIsSuccess,
    },
  ] = useLazyGetAllDropDownsForMemberDirectoryQuery();
  const [
    downloadSheetForGreenMarkProjectList,
    {
      isSuccess: isDownloadSheetForGreenMarkProjectListSuccess,
      isLoading: isDownloadSheetForGreenMarkProjectListFetching,
      data: DownloadSheetForGreenMarkProjectListResponse,
    },
  ] = useDownloadSheetForGreenMarkProjectListMutation();

  useEffect(() => {
    if (
      !DownloadSheetForGreenMarkProjectListResponse &&
      isDownloadSheetForGreenMarkProjectListSuccess &&
      isDownloadSheetForGreenMarkProjectListFetching
    ) {
    }
  }, [
    DownloadSheetForGreenMarkProjectListResponse,
    isDownloadSheetForGreenMarkProjectListSuccess,
    isDownloadSheetForGreenMarkProjectListFetching,
  ]);

  useEffect(() => {
    getGreenMarkProjectList(paginationRequest);
    getAllDropdownData();
  }, []);

  useEffect(() => {
    if (
      !getDropdownDataIsLoading &&
      allDropDownResponse &&
      getAllDropdownDataIsSuccess
    ) {
      setAllDropDownField(allDropDownResponse);
    }
  }, [
    getDropdownDataIsLoading,
    allDropDownResponse,
    getAllDropdownDataIsSuccess,
  ]);

  useEffect(() => {
    if (!isFetchingList && isSuccessList && getGreenMarkProjectListData) {
      setPaginationRequest({
        ...paginationRequest,
        totalCount: getGreenMarkProjectListData.totalCount,
      });
      const updatedDocumentList = getGreenMarkProjectListData?.itemList?.map(
        (documant) => ({
          ...documant,
          certificateLink: `${APIUrl}/Common/getPDF?type=LetterofEndorsement&fileName=${documant?.loa}`,
          certificateLink1: `${APIUrl}/Common/getPDF?type=GreenMarkCategoryFile&fileName=${documant?.loe}`,
        })
      );
      setDataSource(updatedDocumentList);
    }
  }, [isFetchingList, isSuccessList, getGreenMarkProjectListData]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    getGreenMarkProjectList({
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    });
  };

  const handleSearch = () => {
    if (!viewIndividualMembersRef.current) {
      return;
    }
    const taskListFormData = viewIndividualMembersRef.current.getFormData();
    const updatedPaginationRequest = {
      PageNo: 1,
      PageSize: 20,
      SearchText: taskListFormData?.searchText || null,
      Projects: taskListFormData?.projects?.value || null,
      AwardRating: taskListFormData?.awardRating?.value || null,
      GreenMarkProjectCatagory: taskListFormData?.greenMarkCategory?.value || null,
      ProjectNumber:taskListFormData?.projectNumber || null,
      ProjectName:taskListFormData?.projectName || null,

    };
    setPaginationRequest(updatedPaginationRequest);
    getGreenMarkProjectList(updatedPaginationRequest);
  };

  const handleUpdateClick = (data) => {
    navigate(`/editGreenMarkProject/${encryptAESID(data.projectId)}`, {
      state: {
        gmapmemberId: data.gmapMemberId,
        source: data.source,
      },
    });
  };

  const actionHandler = {
    View: handleUpdateClick,
  };

  const handleClear = () => {
    const formData = { ...ViewGreenMarkProjectFormData };
    formData.initialState = {
      SearchText: null,
      Projects: null,
      AwardRating: null,
      GreenMarkProjectCatagory: null,
      ProjectNumber:null,
      ProjectName:null
    };
    let request = {
      ...paginationRequest,
      pageNo: 1,
      pageSize: 20,
      SearchText: null,
      Projects: null,
      AwardRating: null,
      GreenMarkProjectCatagory: null,
      ProjectNumber:null,
      ProjectName:null,
      totalCount: 0,
    };
    setPaginationRequest((prev) => {
      return { ...prev, ...request };
    });
    getGreenMarkProjectList(request);
    setFormData(formData);
  };

  const handleDownload = async () => {
    try {
      const response = await downloadSheetForGreenMarkProjectList({
        PageNo: 1,
        PageSize: 20,
        SearchText: paginationRequest?.SearchText || "",
        Projects: paginationRequest?.Projects || null,
        AwardRating: paginationRequest?.AwardRating || null,
        GreenMarkProjectCatagory:paginationRequest?.GreenMarkProjectCatagory || null,
        ProjectNumber:paginationRequest?.ProjectNumber || null,
        ProjectName:paginationRequest?.ProjectName || null,
      });

      if (response && response.data) {
        const { fileData, fileName } = response.data;
        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName || "download.xlsx");
      }
      handleClear();
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <div className="common-first-section">
      <div className="row align-items-end">
        <div className="col-10">
          <div className="row gx-5">
            {getDropdownDataIsLoading ? (
              <DataLoader />
            ) : (
              <FormCreator ref={viewIndividualMembersRef} {...formData} />
            )}
          </div>
        </div>
        <div className="col-2 d-flex justify-content-end flex-wrap gap-2">
          <div className="two-button-fixes mt-1">
            <div className="">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="success-btn"
                onClick={handleSearch}
              />
            </div>
          </div>
          <div className="two-button-fixes">
            <div className="">
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="black-btn mt-1"
                onClick={handleClear}
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <h3>Total Count : {getGreenMarkProjectListData?.totalCount}</h3>
        </div>
        <div className="flex flex-col space-y-6 mt-3">
          {(paginationRequest?.AwardRating > 0 ||
            paginationRequest?.GreenMarkProjectCatagory > 0) && (
            <div>
              <Buttons
                buttonText="Download Excel"
                buttonTypeClassName="success-btn"
                onClick={handleDownload}
              />
            </div>
          )}
        </div>

        <div className="col-lg-12">
          <div className="common-view-Individual-table">
            <div className="table-responsive view-greenmark-project">
              <MolGrid
                ref={molGridRef}
                configuration={ViewGreenMarkProjectConfig}
                dataSource={dataSource}
                allowPagination={true}
                isLoading={isFetchingList}
                pagination={paginationRequest}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewGreenMarkProjectList;
